import { render } from "./UnassignedPatientVisitsHCHOSPAL.vue?vue&type=template&id=3fb0d228"
import script from "./UnassignedPatientVisitsHCHOSPAL.ts?vue&type=script&lang=js&external"
export * from "./UnassignedPatientVisitsHCHOSPAL.ts?vue&type=script&lang=js&external"

import "./UnassignedPatientVisitsHCHOSPAL.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__